import axios from "axios";

import { OrganizationFormInputs } from "components/forms/OrganizationForm";
import * as types from 'types';

const url = "/organizations";

export const fetchbyId = (id: string) => axios.get(`${url}/${id}`)

export const createNew = (data: OrganizationFormInputs) => axios.post(`${url}/create`, data);